<template>

    <div class="form-check mb-3">

        <input 
            type="radio" 
            :id="id" 
            ref="input" 
            v-bind="$attrs" 
            class="form-check-input" 
            :checked="isChecked" 
            :value="value"
            :class="{ 'is-invalid': error }" 
            @change="$emit('change', $event.target.value)" />

        <label v-if="label" class="form-check-label" :for="id">
            {{ translatedLabel }}
        </label>

        <div v-if="error" class="invalid-feedback">{{ error }}</div>

    </div>

</template>

<script>
    export default {
        inheritAttrs: false,
        model: {
            prop: 'modelValue',
            event: 'change'
        },
        props: {
            id: {
                type: String,
                default() {
                    return `radio-input-${this._uid}`
                },
            },
            modelValue: {
                default: null
            },
            value: {
                type: String,
                default: undefined
            },
            label: String,
            error: String,
        },
        methods: {
            focus() {
                this.$refs.input.focus()
            },
        },
        computed: {
            isChecked() {
                return this.modelValue === this.value;
            },
            translatedLabel() {
                return this.langHas('validation.attributes.' + this.label)
                        ? this.__('validation.attributes.' + this.label)
                        : this.label;
            }
        },

    }
</script>